import _regeneratorRuntime from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/regenerator/index.js";
import React, { useRef, useEffect, Suspense, lazy, useCallback, useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var apiCache = {};
var load = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiCache[url] = apiCache[url] || fetch(url).then(function (response) {
              return response.text();
            }).then(function (text) {
              return Function("\n        var module = {};\n        var exports = {};\n        module.exports = exports;\n        (function(module, exports){\n          ".concat(text, "\n          //# sourceURL=").concat(url, "\n        })(module, exports);\n        return module.exports;\n      "))();
            });
            return _context.abrupt("return", apiCache[url]);
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function load(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _excluded$2 = ["render"];
var Component = function Component(_ref) {
  var render = _ref.render,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var element = useRef();
  useEffect(function () {
    render(element.current, props);
  }, [render, props]);
  return /*#__PURE__*/React.createElement("div", {
    ref: element
  });
};
var remote = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", load(url).then(function (_ref3) {
              var render = _ref3.render;
              return {
                default: function _default(props) {
                  return /*#__PURE__*/React.createElement(Component, _extends({
                    render: render
                  }, props));
                }
              };
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function remote(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      var _this$props$onError, _this$props;
      (_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props, error);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) return null;
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(_error) {
      return {
        hasError: true
      };
    }
  }]);
  return ErrorBoundary;
}(React.Component);
var _excluded$1 = ["src", "component", "fallback", "onError"];
var RemoteComponent = function RemoteComponent(_ref) {
  var src = _ref.src,
    promise = _ref.component,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? console.error : _ref$onError,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var Component = /*#__PURE__*/lazy(function () {
    return promise !== null && promise !== void 0 ? promise : remote(src);
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    onError: onError
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: fallback
  }, /*#__PURE__*/React.createElement(Component, props)));
};
var _excluded = ["url", "scope", "module", "fallback", "loading", "errorCallback"];
var legacyShareScope = {
  react: _defineProperty({}, React.version, {
    get: function get() {
      return new Promise(function (resolve) {
        resolve(function () {
          return React;
        });
      });
    },
    loaded: true,
    from: "webpack4"
  }),
  "react-dom": _defineProperty({}, React.version, {
    get: function get() {
      return new Promise(function (resolve) {
        resolve(function () {
          return ReactDOM;
        });
      });
    },
    loaded: true,
    from: "webpack4"
  })
};
var useDynamicScript = function useDynamicScript(url) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ready = _React$useState2[0],
    setReady = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    failed = _React$useState4[0],
    setFailed = _React$useState4[1];
  useEffect(function () {
    if (!url) {
      return;
    }
    var element = document.createElement("script");
    element.src = url;
    element.type = "text/javascript";
    element.async = true;
    setReady(false);
    setFailed(false);
    element.onload = function () {
      setReady(true);
    };
    element.onerror = function () {
      setReady(false);
      setFailed(true);
    };
    document.head.appendChild(element);
    return function () {
      element.onload = function () {};
      element.onerror = function () {};
      document.head.removeChild(element);
    };
  }, [url]);
  return {
    ready: ready,
    failed: failed
  };
};
function initilizeComponent(_x, _x2) {
  return _initilizeComponent.apply(this, arguments);
}
function _initilizeComponent() {
  _initilizeComponent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(scope, module) {
    var factory;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            window[scope].init(legacyShareScope);
            _context2.next = 3;
            return window[scope].get(module);
          case 3:
            factory = _context2.sent;
            return _context2.abrupt("return", factory());
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _initilizeComponent.apply(this, arguments);
}
function useRemoteComponent(scope, module, fallback) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var Component = useMemo(function () {
    return /*#__PURE__*/lazy(function () {
      return initilizeComponent(scope, module).catch(function (error) {
        setError(error);
        return {
          default: function _default() {
            return fallback;
          }
        };
      });
    });
  }, [scope, module, fallback]);
  return {
    Component: Component,
    error: error
  };
}
var FederatedRemoteComponent = function FederatedRemoteComponent(_ref) {
  var url = _ref.url,
    scope = _ref.scope,
    module = _ref.module,
    fallback = _ref.fallback,
    loading = _ref.loading,
    errorCallback = _ref.errorCallback,
    props = _objectWithoutProperties(_ref, _excluded);
  var sendErrorToLuker = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
      var sendEvent;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sendEvent = errorCallback ? errorCallback : console.log;
              sendEvent("error_message", "remote_component", {
                url: url,
                module: module,
                scope: scope,
                error: error.message
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [url, module, scope]);
  var _useDynamicScript = useDynamicScript(url),
    ready = _useDynamicScript.ready,
    failed = _useDynamicScript.failed;
  useEffect(function () {
    failed && sendErrorToLuker(new Error("failed to load remote entry"));
  }, [sendErrorToLuker, failed]);
  var _useRemoteComponent = useRemoteComponent(scope, module, fallback),
    Component = _useRemoteComponent.Component,
    error = _useRemoteComponent.error;
  useEffect(function () {
    error && sendErrorToLuker(error);
  }, [sendErrorToLuker, error]);
  if (failed) {
    return fallback;
  }
  if (!ready) {
    return loading;
  }
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    onError: sendErrorToLuker,
    fallback: fallback
  }, /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: loading
  }, /*#__PURE__*/React.createElement(Component, props)));
};
export { ErrorBoundary, FederatedRemoteComponent, RemoteComponent, load as loadModule, remote };